import actionTypes from '../../../redux/actions/action-types';

export const getTeamThemes = (data) => ({
  type: actionTypes.themesPage.getTeamThemes,
  data,
});

export const setAction = (data) => ({
  type: actionTypes.themesPage.set,
  data,
});
